// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import PlantEquipmentHirePage from "../pages/PlantEquipmentHire/PlantEquipmentHire";
const __wvcRoutePaths = ["/PlantEquipmentHirePage", "/plant-equipment-hire"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["about-us", "aboutuspage", "compliance", "compliancepage", "contact", "contactpage", "core-services", "coreservicespage", "home", "homepage", "plant-equipment-hire", "plantequipmenthirepage", "post", "resources", "resourcespage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<PlantEquipmentHirePage />} />
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<PlantEquipmentHirePage />} />
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
